import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import axios from 'axios';
import App from './App';
import './index.css';
import '@medical/shared/i18n';
import { API_BASE_URL } from '@medical/shared/config/api';

if (API_BASE_URL) {
  axios.defaults.baseURL = API_BASE_URL;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 2000,
          style: { background: '#363636', color: '#fff' },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
);
